// extracted by mini-css-extract-plugin
export default {"container":"Caption_container__y24l1"};